import { render, staticRenderFns } from "./MutualSettlements.vue?vue&type=template&id=bff2f64a&scoped=true"
import script from "./MutualSettlements.vue?vue&type=script&lang=ts"
export * from "./MutualSettlements.vue?vue&type=script&lang=ts"
import style0 from "./MutualSettlements.vue?vue&type=style&index=0&id=bff2f64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff2f64a",
  null
  
)

export default component.exports